// extracted by css-extract-rspack-plugin
export default {"dividerLine":"HeaderMetadataDivider-module__dividerLine__LLxCn"};